import script from "./AnchorGift.vue?vue&type=script&setup=true&lang=js"
export * from "./AnchorGift.vue?vue&type=script&setup=true&lang=js"

import "./AnchorGift.vue?vue&type=style&index=0&id=07c747b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07c747b0"]])

export default __exports__